angular.module('unergie.main')
.controller('batchOperationModalCtrl', ($scope, $timeout, $uibModalInstance, DataAccessSearch, DataAccess, ApiUser, XmlParser, FileUploader, AlertManager, Sequentializer, ErrorCatcher) => {
    $scope.operations = [
        {
            id: 'refresh-prm', // mandatory
            label: 'Consulter Point', // mandatory
            details: `Uploadez un fichier CSV avec 1 colonne "id_prm", séparateur utilisé ','`, // mandatory
            functionalId: 'id_prm', // mandatory
            check: (line) => !!line.id_prm, // optional but highly recommended
            filter: (lines) => { // optional filter (to replay same file without relaunching already processed)
                if (lines.length > 500) {
                    $scope.errorMessage = `Impossible de filter un fichier de plus de 500 lignes, copiez cette requête dans Metabase pour régénérer un fichier CSV`
                    $scope.metabaseRequest = `select id as id_prm from urg_client.urg_prm `
                        + `where last_eligibility_date < '${moment().add(-1, 'day').startOf('day').toISOString()}' and id in ('${_.map(lines, 'id_prm').join(`','`)}')`
                    return AlertManager.error(`Impossible de filter un fichier de plus de 500 lignes`)
                }
                return DataAccessSearch({
                    columns: ['id'],
                    limit: lines.length,
                    gt: [`last_eligibility_date=${moment().add(-1, 'day').startOf('day').toISOString()}`],
                    in: [`id=${_.map(lines, 'id_prm').join(',')}`],
                })
                .searchPaginated({ resource: 'prms' }).$promise
                .then((data) => {
                    const alreadyProcessIds = _.map(data.results, 'id')
                    return _.filter(lines, (line) => !alreadyProcessIds.includes(line.id_prm))
                })
                .catch(ErrorCatcher)
            },
            additional: { // optional - popupconfirm style
                params: { // mandatory if additional
                    strict: false,
                },
                fields: { // mandatory if additional
                    strict: {
                        label: `Ne pas enregistrer les PRM en erreur`,
                        type: 'checkbox',
                    },
                },
            },
            func: (line, params) => { // mandatory
                return ApiUser.fetchPRM({ id_prm: line.id_prm, pro: true, strict: params.strict }).$promise
            },
            testError: (line, result) => { // mandatory
                return {
                    success: result.eligible,
                    message: result.eligible ?
                        `${line.id_prm} : ${result.power.max}kVA - ${result.plan.id_p_calendar} - ${result.routing_tariff}` :
                        `${line.id_prm} : ${result.code} - ${result.message}`,
                }
            },
            resultRequest: (lines) => `select * from urg_client.urg_prm where id in ('${_.map(lines, 'id_prm').join(`','`)}')`, // optional
        },
        {
            id: 'cmd-c5-pmax', // mandatory
            label: 'Consulter Mesures Détaillées - C5 - PMAX', // mandatory
            details: `Uploadez un fichier CSV avec 3 colonnes "id_contract" / "start_date" (YYYY-MM-DD) / "end_date" (YYYY-MM-DD), séparateur utilisé ','<br>`
                + `Il est possible de récupérer 3 ans d'historique maximum, limité à la dernière mise en service du PRM`, // mandatory
            functionalId: 'id_contract', // mandatory
            check: (line) => !!line.id_contract && !!line.start_date && !!line.end_date && moment(line.start_date).isBefore(moment(line.end_date)), // optional but highly recommended
            func: (line) => { // mandatory
                return ApiUser.retrieveMeasure({ id_contract: line.id_contract, kind: 'PMAX', startDate: line.start_date, endDate: line.end_date }).$promise
            },
            testError: (line, result) => { // mandatory
                return { success: true, message: `${line.id_contract} : OK` }
            },
        },
        {
            id: 'cmd-c5-cdc', // mandatory
            label: 'Consulter Mesures Détaillées - C5 - CDC', // mandatory
            details: `Uploadez un fichier CSV avec 3 colonnes "id_contract" / "start_date" (YYYY-MM-DD) / "end_date" (YYYY-MM-DD), séparateur utilisé ','<br>`
                + `Il n'est possible de récupérer que 7 jours consécutifs par appel. Pour récupérer un an d'historique pour un PRM, il faut donc faire 52 lignes (une par semaine)<br>`
                + `Il est possible de récupérer 2 ans d'historique maximum, limité à la dernière mise en service du PRM`, // mandatory
            functionalId: 'id_contract', // mandatory
            check: (line) => !!line.id_contract && !!line.start_date && !!line.end_date && moment(line.start_date).isBefore(moment(line.end_date)), // optional but highly recommended
            func: (line) => { // mandatory
                return ApiUser.retrieveMeasure({ id_contract: line.id_contract, kind: 'CDC', startDate: line.start_date, endDate: line.end_date }).$promise
            },
            testError: (line, result) => { // mandatory
                return { success: true, message: `${line.id_contract} : OK` }
            },
        },
        {
            id: 'compensation-creation', // mandatory
            label: 'Création de méta facture de rétribution', // mandatory
            details: `Uploadez un fichier CSV avec 5 colonnes :<br>`
                + `"id_category" : id du paquet facturier<br>`
                + `"compensation_amount" : montant de la rétribution HT (en euro, avec un point en séparateur de décimales)<br>`
                + `"compensation_vat_rate" : taux de TVA (0, 5.5 ou 20)<br>`
                + `"compensation_label" : note à afficher dans la facture<br>`
                + `"period_start_date" : date de début de la période au format YYYY-MM-DD<br>`
                + `"period_end_date" : date de fin de la période au format YYYY-MM-DD<br>`
                + `séparateur utilisé ','<br>`, // mandatory
            functionalId: 'id_category', // mandatory
            check: (line) => (!!line.id_category
                    && !!line.compensation_amount
                    && !!line.compensation_vat_rate
                    && !!line.compensation_label
                    && !!line.period_start_date
                    && !!line.period_end_date), // optional but highly recommended
            func: (line) => { // mandatory
                return DataAccess.createCompensationMeta({
                    id_category: line.id_category,
                    compensation_amount: line.compensation_amount,
                    compensation_vat_rate: line.compensation_vat_rate,
                    compensation_label: line.compensation_label,
                    period_start_date: line.period_start_date,
                    period_end_date: line.period_end_date,
                }).$promise
            },
            testError: (line, result) => { // mandatory
                return { success: true, message: `${line.id_category} : OK` }
            },
        },
    ]

    $scope.scroll = true

    $scope.switchObject = {
        running: false,
    }

    $scope.runStats = {}

    $scope.concurrency = 4
    $scope.delay = 150

    $scope.filterData = false

    $scope.selectedOperation = $scope.operations[0]

    const resetRun = () => {
        $scope.runStats = {
            total: 0,
            ok: 0,
            ko: 0,
            results: [],
        }
        $scope.errorMessage = null
        $scope.elementList = null
        $scope.resultRequest = null
    }

    $scope.onOperationChange = resetRun

    $scope.genericCsvUploader = new FileUploader({
        url: `/api-admin/s3-upload`,
        alias: 'file',
        formData: [],
        autoUpload: true,
        method: 'POST',
        onBeforeUploadItem(item) {
            resetRun()
            item.formData.push({ bucketName: 'files', path: `mass-operations/${$scope.selectedOperation.id}` })
        },
        onSuccessItem(item, response, status, headers) {
            AlertManager.success(`Fichier uploadé - lecture du fichier`)
            $scope.parsing = true
            const payload = {
                source: 's3',
                replay: true,
                bucket: response.bucket,
                type: 'generic-csv',
                filename: response.path,
            }
            return XmlParser.parsing(payload).$promise.then((result) => {
                if ($scope.selectedOperation.check) {
                    AlertManager.success(`Fichier parsé - vérification des données`)
                    const errors = _.filter(result.processed, (elem) => !$scope.selectedOperation.check(elem))
                    if (errors.length) {
                        AlertManager.error(`Le fichier ne présente pas les colonnes/données essentielles`)
                        $scope.errorMessage = `Le fichier comporte ${errors.length} lignes en erreur, liste disponible en console`
                        console.log(`Erreurs`, errors)
                        return
                    }
                }
                if ($scope.selectedOperation.filter && $scope.filterData) {
                    return $scope.selectedOperation.filter(result.processed).then((filteredResults) => {
                        $scope.elementList = filteredResults
                    })
                }
                $scope.elementList = result.processed

                $scope.runStats.total = $scope.elementList.length

                if ($scope.selectedOperation.resultRequest) {
                    $scope.resultRequest = $scope.selectedOperation.resultRequest($scope.elementList)
                }
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.parsing = false
            })
        },
        onErrorItem(item, response, status, headers) {
            AlertManager.error(response.message, 10000)
        },
    })

    $scope.launch = () => {
        $scope.runStats = {
            total: $scope.elementList.length,
            ok: 0,
            ko: 0,
            results: [],
            start: moment(),
        }

        const promiseFunc = (line) => {
            return Promise.resolve()
            .then(() => {
                return $scope.selectedOperation.func(line, $scope.selectedOperation.additional && $scope.selectedOperation.additional.params)
            })
            .then((result) => {
                const { success, message } = $scope.selectedOperation.testError(line, result)
                if (success) {
                    $scope.runStats.ok += 1
                } else {
                    $scope.runStats.ko += 1
                }
                if (message) {
                    $scope.runStats.results.push({ success, message })
                }
            })
            .catch((error) => {
                $scope.runStats.ko += 1
                $scope.runStats.results.push({
                    success: false,
                    message: `${line[$scope.selectedOperation.functionalId]} - ${error.message || error.error || (error.data && error.data.message) || JSON.stringify(error)}`,
                })
            })
            .finally(() => {
                $scope.runStats.duration = moment().diff($scope.runStats.start, 'second')
                const ratioDone = ($scope.runStats.ok + $scope.runStats.ko) / $scope.runStats.total
                $scope.runStats.eta = moment($scope.runStats.start).add($scope.runStats.duration * (1 / ratioDone), 'second')
            })
        }
        $scope.switchObject.running = true
        return Sequentializer.map($scope.elementList, promiseFunc, { concurrency: $scope.concurrency, delay: $scope.delay, switchObject: $scope.switchObject })
        .then(() => {
            console.log(`runStats:`, $scope.runStats)
            $timeout(() => {
                AlertManager.success(`"${$scope.selectedOperation.label}" terminé.`)
            })
        })
        .finally(() => {
            $scope.switchObject.running = false
        })
    }

    $scope.copied = () => AlertManager.success(`Copié !`)

    $scope.stop = () => {
        $scope.switchObject.running = false
    }

    $scope.copyResult = () => {
        return _.map($scope.runStats.results, 'message').join('\n')
    }

    $scope.$on('$destroy', $scope.stop)

    $scope.ok = $uibModalInstance.close
    $scope.close = $uibModalInstance.dismiss
})
